import React, { useState } from 'react'
import Flatpickr from 'react-flatpickr';
// import 'flatpickr/dist/themes/material_green.css'
import { Thai } from 'flatpickr/dist/l10n/th.js'

import ShortcutButtonsPlugin from 'shortcut-buttons-flatpickr'

import classnames from 'classnames';
import { makeStyles } from '@material-ui/styles';

import { getYear, addYears } from 'date-fns';

import yearDropdownPlugin from './YearDropdownPlugin'
import FormHelperText from '@material-ui/core/FormHelperText';

// import { minMaxTimePlugin } from 'flatpickr/dist/plugins/minMaxTimePlugin'

import './Themeflat.css'

const UseStyles = makeStyles(theme => ({
    textField: {
        [`& input`]: {
            height: theme.field.height,
            padding: theme.field.padding,
            fontSize: theme.fontSize.body1
        },
        // marginTop: '2px',
        width: '100%',
        boxShadow: theme.field.boxShadow
    },
    formHelper: {
        color: theme.mainTheme.color5,
        marginTop: '1px',
        marginLeft: '10px'
    },
    label: {
        color: theme.mainTheme.color1
    },
    error: {
        color: theme.mainTheme.color5
    },
    badge: {
        top: '25px',
        right: '14px',
        fontSize: '12px'
    },
    icon: {
        color: theme.mainTheme.color6,
        width: '25px',
        height: '25px'
    },
    asterisk: {
        color: '#FF0000'
    },
    inputFlat: {
        width: '100%',
        borderRadius: '4px',
        height: '40px',
        border: '1px solid #cbcbcb',
        padding: '0px 15px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 3px 7px 0px',
        '&:hover': {
            border: '1px solid #000000',
        },
        '&:focus': {
            outlineColor: 'unset',
            outline: 'unset',
            border: `2px solid ${theme.mainTheme.color1}`
        }
    },
    inputFlatErr: {
        width: '100%',
        borderRadius: '4px',
        height: '40px',
        border: `1px solid ${theme.mainTheme.color5}`,
        padding: '0px 15px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 3px 7px 0px',
        '&:hover': {
            border: '1px solid #000000',
        },
        '&:focus': {
            outlineColor: 'unset',
            outline: 'unset',
            border: `2px solid ${theme.mainTheme.color5}`
        }
    }
}));

const Dateflat = ({
    label,
    input,
    required,
    meta: { error, touched, invalid, active, submitFailed },
    placeholder = 'วัน/เดือน/ปี ชั่วโมง/นาที',
    onChange,
    minDate,
    maxDate,
    id
}) => {

    const classes = UseStyles()
    const asterisk = required ? (
        <span className={classes.asterisk}> *</span>
    ) : (
            ''
        );
    const isError = touched && invalid && error ? true : false;

    const [date, setDate] = useState()
    // const [isPrev, setIsPrev] = useState(true)

    if (input.value !== '' && !date) {
        setDate(input.value)
    } else if (input.value !== "" && input.value !== date) {
        setDate(input.value)
    }

    if (input.value === '' && date) {
        setDate()
    }

    const handleChange = (dt) => {
        if (dt[0]) {
            input.onChange(dt[0])
            setDate(dt[0])
            onChange && onChange(dt[0])
        } else {
            input.onChange('')
            setDate('')
        }
    }

    const convertYearToBD = (dt) => {
        return addYears(dt, 543)
    }

    const options = {
        plugins: [
            new yearDropdownPlugin({
                date: Array.isArray(date) ? date[0] : date,
                yearStart: new Date(date).getFullYear() - 10,
                yearEnd: new Date(date).getFullYear() + 10,
                name: id
            }),
            ShortcutButtonsPlugin({
                button: {
                    label: 'ล้างค่า',
                },
                onClick: (index, fp) => {
                    fp.clear();
                    fp.close()
                }
            }),
        ],
        enableTime: true,
        dateFormat:
            date
                ? `d M ${getYear(convertYearToBD(date))} H:i`
                : `d M YY H:i`
        ,
        time_24hr: true,
        locale: Thai,
        static: true,
        minuteIncrement: 15,
        minDate: minDate && minDate,
        maxDate: maxDate && maxDate,
        disableMobile: "true",
        onOpen: [
            function (selectedDates, dateStr, instance) {
                if (selectedDates && selectedDates.length > 0) {
                    if (instance.yearSelectContainer) {
                        document.getElementById(id).value = selectedDates[0].getFullYear()
                    }
                    instance.changeMonth(selectedDates[0].getMonth(), false)
                    instance.changeYear(selectedDates[0].getFullYear())
                } else {
                    let currentYear = new Date()
                    if (instance.yearSelectContainer && document.getElementById(id)) {
                        document.getElementById(id).value = currentYear.getFullYear()
                    }
                    instance.changeMonth(currentYear.getMonth(), false)
                    instance.changeYear(currentYear.getFullYear())
                }
            }
        ]

    }

    return (
        <div id='source' style={{ height: '90px' }}>
            <label
                className={classnames(classes.label, {
                    [classes.error]: isError
                })}
            >
                {label}
                {asterisk}
            </label>
            <Flatpickr
                data-enable-time
                value={date}
                options={options}
                onChange={handleChange}

                render={({ defaultValue }, ref) => {
                    return (
                        <div>
                            <input className={touched && invalid && error ? classes.inputFlatErr : classes.inputFlat} value={date} ref={ref} placeholder={placeholder} />
                        </div>
                    )
                }} />

            <FormHelperText className={classes.formHelper}>
                {touched && invalid && error}
            </FormHelperText>
        </div>

    )
}

export default Dateflat

